import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, Grid, MenuItem, CircularProgress, DialogContentText
} from '@mui/material';
import { createTenantUserApi } from 'backendServices/ApiCalls';

const CreateUserModal = ({ open, onClose, GetUsersList, setalertData }) => {
  const [formData, setFormData] = useState({
    mobile: "",
    email: "",
    country: "",
    company: "",
    address: "",
    zip_code: "",
    city: "",
    language: "en-US",
    first_name: "",
    last_name: "",
    item_id: "Select Plan",
    admin_transaction_password: "",
    in_trial: false
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (!open) {
      setFormData({
        mobile: "",
        email: "",
        country: "",
        company: "",
        address: "",
        zip_code: "",
        city: "",
        language: "en-US",
        first_name: "",
        last_name: "",
        item_id: "Select Plan",
        admin_transaction_password: "",
        in_trial: false
      });
      setErrors({});
    }
  }, [open]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.first_name) tempErrors.first_name = "First name is required";
    if (!formData.last_name) tempErrors.last_name = "Last name is required";
    if (!formData.email) tempErrors.email = "Email is required";
    if (!formData.mobile) tempErrors.mobile = "Mobile is required";
    if (!formData.country) tempErrors.country = "Country is required";
    if (!formData.address) tempErrors.address = "Address is required";
    if (!formData.city) tempErrors.city = "City is required";
    if (!formData.zip_code) tempErrors.zip_code = "Zip code is required";
    if (!formData.language) tempErrors.language = "Language is required";
    if (!formData.item_id || formData.item_id === "Select Plan") tempErrors.item_id = "Item ID is required";
    if (!formData.admin_transaction_password) tempErrors.admin_transaction_password = "Transaction password is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setShowConfirm(true);
  };

  const handleConfirmSubmit = () => {
    setLoading(true)
    try {
      createTenantUserApi(formData, (response) => {
        if (response?.data?.status === "error") {
          setalertData({
            show: true,
            message: response?.data?.message || "Error creating user",
            variant: "error"
          });
        } else {
          setalertData({
            show: true,
            message: "User created successfully",
            variant: "success"
          });
          setShowConfirm(false);
          onClose();
          GetUsersList();
        }
        setLoading(false);
      }, (error) => {
        setalertData({
          show: true,
          message: error?.response?.data?.message || "Something went wrong please try again later",
          variant: "error"
        });
        setShowConfirm(false);
        setLoading(false);
      });
    } catch (error) {
      setalertData({
        show: true,
        message: "Something went wrong please try again later",
        variant: "error"
      });
      setShowConfirm(false);
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Create User</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="First Name" name="first_name" value={formData.first_name} onChange={handleChange} error={!!errors.first_name} helperText={errors.first_name} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Last Name" name="last_name" value={formData.last_name} onChange={handleChange} error={!!errors.last_name} helperText={errors.last_name} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Email" name="email" value={formData.email} onChange={handleChange} error={!!errors.email} helperText={errors.email} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} error={!!errors.mobile} helperText={errors.mobile} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Company" name="company" value={formData.company} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Country" name="country" value={formData.country} onChange={handleChange} error={!!errors.country} helperText={errors.country} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Address" name="address" value={formData.address} onChange={handleChange} error={!!errors.address} helperText={errors.address} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="City" name="city" value={formData.city} onChange={handleChange} error={!!errors.city} helperText={errors.city} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Zip Code" name="zip_code" value={formData.zip_code} onChange={handleChange} error={!!errors.zip_code} helperText={errors.zip_code} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                required
                label="Language"
                name="language"
                value={formData.language}
                onChange={handleChange}
                error={!!errors.language}
                helperText={errors.language}
              >
                <MenuItem value="en-US">English</MenuItem>
                <MenuItem value="fr-FR">French</MenuItem>
                <MenuItem value="pt-PT">Portuguese</MenuItem>
                <MenuItem value="de-DE">German</MenuItem>
                <MenuItem value="es-ES">Spanish</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                required
                label="Plan"
                name="item_id"
                value={formData.item_id}
                onChange={handleChange}
                error={!!errors.item_id}
                helperText={errors.item_id}
              >
                <MenuItem value="Select Plan" disabled>Select Plan</MenuItem>
                <MenuItem value="Basic-wl-akquise-EUR-Monthly">Basic-wl-akquise-EUR-Monthly</MenuItem>
                <MenuItem value="Starter-wl-akquise-EUR-Monthly">Starter-wl-akquise-EUR-Monthly</MenuItem>
                <MenuItem value="Business-wl-akquise-EUR-Monthly">Business-wl-akquise-EUR-Monthly</MenuItem>
                <MenuItem value="Basic-wl-akquise-EUR-Yearly">Basic-wl-akquise-EUR-Yearly</MenuItem>
                <MenuItem value="Starter-wl-akquise-EUR-Yearly">Starter-wl-akquise-EUR-Yearly</MenuItem>
                <MenuItem value="Business-wl-akquise-EUR-Yearly">Business-wl-akquise-EUR-Yearly</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                required
                label="In Trial"
                name="in_trial"
                value={formData.in_trial}
                onChange={handleChange}
                error={!!errors.in_trial}
                helperText={errors.in_trial}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                label="Transaction Password"
                name="admin_transaction_password"
                type="password"
                value={formData.admin_transaction_password}
                onChange={handleChange}
                error={!!errors.admin_transaction_password}
                helperText={errors.admin_transaction_password}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
        <DialogTitle>Confirm Creation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You are creating a new user and this account will be added to the next invoice.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirm(false)}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmSubmit} disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Yes, create the account"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateUserModal;
